import React from "react";

// Place the PDFs in public/assets/pdf/RightsIssue/ with these file names
const documents = [
  {
    title: "Draft Letter of Offer",
    pdf: "/assets/pdf/RightsIssue/Draft-Letter-of-Offer.pdf",
  },
  {
    title: "IN PRINCIPAL APPROVAL LETTER-NSE",
    pdf: "/assets/pdf/RightsIssue/IN-PRINCIPAL-APPROVAL-LETTER-NSE.pdf",
  },
  {
    title: "Letter of Offer",
    pdf: "/assets/pdf/RightsIssue/Letter-of-Offer.pdf",
  },
  {
    title: "Application Form",
    pdf: "/assets/pdf/RightsIssue/Application-form.pdf",
  },
  {
    title: "Plain Application Form",
    pdf: "/assets/pdf/RightsIssue/Plain-application-form.pdf",
  },
  {
    title: "Rights Eentitlement Letter",
    pdf: "/assets/pdf/RightsIssue/Rights-entitlement-letter.pdf",
  },
];

const RightsIssue = () => {
  return (
    <>
      <section className="breadcrum-document">
        <div className="container-fluid">
          <div className="row">
            <div className="d-flex justify-content-center align-items-center text-decoration-none breadcrum_anchor">
              <h1 className="text-white">Rights Issue 2026</h1>
            </div>
          </div>
        </div>
      </section>

      <section className="rights-section">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="rights-heading">Rights Issue 2026</h2>
            <p className="rights-subheading">
              Explore the Rights Issue 2026 and access important information
              and documents for eligible shareholders.
            </p>
          </div>

          <div className="row g-4">
            {documents.map((doc) => (
              <div className="col-lg-6 col-12" key={doc.title}>
                <a
                  href={doc.pdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rights-card"
                >
                  <span className="rights-card-icon">
                    <svg viewBox="0 0 48 60" width="46" height="58" aria-hidden="true">
                      <path
                        d="M4 2h28l14 14v40a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"
                        fill="#fff"
                        stroke="#80b451"
                        strokeWidth="3"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M32 2v14h14"
                        fill="none"
                        stroke="#80b451"
                        strokeWidth="3"
                        strokeLinejoin="round"
                      />
                      <rect x="11" y="28" width="22" height="4" rx="2" fill="#80b451" />
                      <rect x="11" y="37" width="22" height="4" rx="2" fill="#80b451" />
                      <rect x="11" y="46" width="16" height="4" rx="2" fill="#80b451" />
                    </svg>
                  </span>
                  <span className="rights-card-title">{doc.title}</span>
                  <span className="rights-card-download" aria-label="Download">
                    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
                      <path
                        d="M12 4v11m0 0l-5-5m5 5l5-5M5 20h14"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default RightsIssue;
